<template>
  <div class="locale-switcher" :class="{ 'locale-switcher--floating': floating }">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="locale-switcher__btn"
      :class="{ active: locale === option.value }"
      :title="option.label"
      @click="changeLocale(option.value)"
    >
      <span class="flag-icon" :class="`flag-icon-${option.flag}`"></span>
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { LOCALE_OPTIONS } from '@/utils/locale'

export default {
  props: {
    floating: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('app', ['locale']),
    options() {
      return LOCALE_OPTIONS
    },
  },
  methods: {
    ...mapActions('app', ['setLocale']),
    changeLocale(locale) {
      this.setLocale({ locale, i18n: this.$i18n })
    },
  },
}
</script>

<style scoped>
.locale-switcher {
  display: inline-flex;
  gap: 0.35rem;
  padding: 0.2rem;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.04);
}

.locale-switcher--floating {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 10;
}

.locale-switcher__btn {
  border: 0;
  background: transparent;
  padding: 0.2rem;
  border-radius: 6px;
  cursor: pointer;
  line-height: 0;
  opacity: 0.55;
  transition: opacity 0.15s ease, box-shadow 0.15s ease;
}

.locale-switcher__btn .flag-icon {
  width: 1.5em;
  line-height: 1.1em;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08);
}

.locale-switcher__btn.active {
  opacity: 1;
  box-shadow: 0 0 0 2px var(--wc-primary);
  border-radius: 6px;
}
</style>
